import { APICore } from "../apiCore";

const api = new APICore();

function getHeaderNavData() {
    return api.get(`/pages/header`);
}

function getLandingPageData() {
  return api.get(`/pages/landing`);
}

function getGenrePageData(genreSlug: string) {
    return api.get(`/pages/genre/${ genreSlug }`);
}

function getGenreFooterMedia(genreSlug: string) {
    return api.get(`/genre/${ genreSlug }/footer`);
}

function getShowDetailPage(genreSlug: string, showSlug: string) {
  return api.get(`/genre/${ genreSlug }/show/${ showSlug }`);
}

export { getHeaderNavData, getLandingPageData, getGenrePageData, getGenreFooterMedia, getShowDetailPage };